import React from "react";

function AboutUs() {
  return (
    <section className="relative py-20  text-white overflow-hidden">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/70"></div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 lg:px-12">
        {/* Title */}
        <h2 className="text-4xl font-bold text-center mb-10  decoration-gray-300 underline-offset-4 pb-2 w-fit  mx-auto">
          About Us
        </h2>

        {/* Grid Layout */}
        <div className="items-start">
          {/* Left Column - About */}
          <div className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10 shadow-md hover:bg-white/10 transition-all duration-500">
            <h1 className="text-lg text-center md:text-xl text-gray-200 mb-6 leading-relaxed">
              Redecor Group is a multidisciplinary design and finishing company
              , with headquarters in Egypt and Qatar. Our
              talented team combines technical expertise with artistic vision to
              deliver world-class projects, from luxury villas and retail stores
              to corporate offices and hospitality spaces.
            </h1>
          </div>

          {/* Right Column - Vision */}
          {/* <div className=" p-8 rounded-xl shadow-lg">
            <h3 className="text-2xl font-semibold  mb-4">
              Vision
            </h3>
            <p className="text-lg md:text-xl text-gray-200 leading-relaxed">
              At Redecor Group, we aim to redefine spaces by blending
              innovation, functionality, and aesthetics. Our mission is to
              exceed expectations through superior quality, meticulous
              attention to detail, and outstanding customer service.
            </p>
          </div> */}
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
